import React from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import Attribute from 'marketing/common/attribute';

const InactiveUser = () => {
  return (
    <div className="error-page l-content">
      <Meta
        title="This person is inactive"
        meta={[{ name: "robots", content: "noindex,nofollow" }]}
      />
      <div id="content" className="row">
        <div className="small-16 medium-8 column error-content align-middle">
          <h1>
            The person you're looking for doesn't have an active profile.
          </h1>
          <p>
            But don't worry, you can <Link to="/explore/creatives/">explore</Link> thousands
            of active creatives. Please <Link to="/help/contact/">contact our support team</Link> if you have any questions.</p>
        </div>
        <div className="small-16 medium-8 columns">
          <div className="error-image">
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring-inactive-account-Dogwings.png" alt="artwork by Dogwings"/>
            <Attribute to="Dogwings"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InactiveUser;



// WEBPACK FOOTER //
// ./profile/components/inactive_user.jsx